import Image from "next/image";
import cn from "classnames";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import s from "./Destination.module.scss";
import { getPageFolderName } from "@config/cms";

const Destination = ({ className, destination }) => {
  const { t } = useTranslation();
  const { img, slug, cityName } = destination;

  return (
    <Link
      href={`/${getPageFolderName().destination}/${slug}`}
      className={cn(s.destination, className)}
    >
      <Image
        fill
        style={{
          objectFit: 'cover',
          objectPosition: 'center'
        }}

        src={img}
        quality={100}
        sizes="(max-width: 340px) 100vw, 340px"
        alt={`City ${cityName}`}
      />
      <div className={s.nameDirections}>{t(cityName)}</div>
      <div className={s.discover}>{t("discover")}</div>
    </Link>
  );
};

export default Destination;
